import { PropsWithChildren, useRef } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { FormSegmentLabelCountBadge } from './FormSegmentLabelCountBadge';
import { FormSegmentLabelFaultColorBg } from './FormSegmentLabelFaultColorBg';
import { Flex } from 'antd';

export interface FormSegmentLabelProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
> extends PropsWithChildren {
  segmentValue: string | number;
  formFieldName?: Name | Name[];
}

export const FormSegmentLabel = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData> = FieldPath<FormData>
>(
  props: FormSegmentLabelProps<FormData, Name>
) => {
  const { formFieldName, children } = props;
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <Flex ref={ref} gap="small" align="center">
      {children}
      {formFieldName && (
        <>
          <FormSegmentLabelCountBadge<FormData, Name>
            name={
              Array.isArray(formFieldName) ? formFieldName : [formFieldName]
            }
          />
          <FormSegmentLabelFaultColorBg<FormData, Name>
            name={formFieldName}
            labelElementRef={ref}
          />
        </>
      )}
    </Flex>
  );
};
